import styled, { css } from 'styled-components';

interface PaymentSectionLayoutProps {
  hasFooter: boolean;
}

const Wrapper = styled.div`
  ${({ theme }) => theme.font.mainFont()};
  display: flex;
  overflow: auto;
  flex-direction: column;
  font-size: 14px;
  line-height: 20px;
  position: absolute;
  height: 100%;
  width: 100%;
  background:
    radial-gradient(600px 300px at 50% -60px, rgba(0, 194, 222, 0.06) 0%, transparent 70%),
    linear-gradient(180deg, #f8fbff 0%, #f1f5f9 40%, #e8eef5 100%);
  color: #0f172a;

  @media (min-width: 768px) {
    background:
      radial-gradient(1000px 460px at 18% -6%, #dbeafe 0%, transparent 62%),
      radial-gradient(860px 380px at 88% -3%, #e0e7ff 0%, transparent 65%),
      radial-gradient(500px 250px at 50% 200px, rgba(0, 194, 222, 0.04) 0%, transparent 70%),
      linear-gradient(180deg, #f8fbff 0%, #eff4fa 100%);
  }
`;

const PaymentSectionLayout = styled.div<PaymentSectionLayoutProps>`
  flex: 1 0 auto;
  margin-bottom: ${({ hasFooter }) => (hasFooter ? '88px' : '24px')};
  padding: 0;

  @media (min-width: 768px) {
    padding: 0 24px;
  }

  ${({ theme: { mui } }) => css`
    ${mui.breakpoints.up('xl')} {
      display: grid;
      grid-template-columns: 1fr 1fr;
      grid-column-gap: 80px;
      max-width: 1150px;
      margin: 54px auto 0;
      width: 100%;
      padding: 0;
    }

    ${mui.breakpoints.down('xs')} {
      margin-top: 0px;
      width: 100%;
    }
  `}
`;

export { Wrapper, PaymentSectionLayout };
